module.exports = __webpack_public_path__ + "img/dfhs.9916e15c.jpg";